export let AddressEntryType;

(function (AddressEntryType) {
  AddressEntryType[AddressEntryType["None"] = 0] = "None";
  AddressEntryType[AddressEntryType["Shipping"] = 1] = "Shipping";
  AddressEntryType[AddressEntryType["Billing"] = 2] = "Billing";
})(AddressEntryType || (AddressEntryType = {}));

export let AddressFormType;

(function (AddressFormType) {
  AddressFormType["CheckoutAddress"] = "checkout_address";
  AddressFormType["GenerateLabelAddress"] = "generate_label_address";
})(AddressFormType || (AddressFormType = {}));

export let AddressField;

(function (AddressField) {
  AddressField["Country"] = "country";
  AddressField["Name"] = "name";
  AddressField["Line1"] = "line1";
  AddressField["Line2"] = "line2";
  AddressField["PostalCode"] = "postal_code";
  AddressField["City"] = "city";
})(AddressField || (AddressField = {}));